import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { Router } from '@angular/router'

@Component({
    selector: 'app-error403',
    standalone: true,
    imports: [],
    templateUrl: './error403.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Error403Component {
    private router = inject(Router)

    goHome() {
        this.router.navigate(['/'])
    }
}
